<template>
  <div>
    <!-- Menú para roles de liquidación (5 y 6) -->
    <!-- <div v-if="[5].includes(auth.user.role)"> -->
    <div v-if="auth.user.role === 5">
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/liquidation">
          <icon name="discount" class="mr-2 w-4 h-4" :class="isUrl('liquidation') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('liquidation') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Liquidación</div>
        </Link>
      </div>
    </div>
    <!-- Menú para rol 1 (solo pedidos) -->
    <div v-else-if="auth.user.role === 1">
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders/employee">
          <icon name="order" class="mr-2 w-4 h-4" :class="isUrl('orders/employee') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('orders/employee') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Pedidos</div>
        </Link>
      </div>
    </div>
    <!-- Menú para otros roles -->
    <div v-else>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/">
          <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Dashboard</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/clients">
          <icon name="store" class="mr-2 w-4 h-4" :class="isUrl('clients') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('clients') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Clientes</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/products">  
          <icon name="product" class="mr-2 w-4 h-4" :class="isUrl('products') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('products') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Productos</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders">
          <icon name="order" class="mr-2 w-4 h-4" :class="isUrl('orders') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('orders') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Pedidos</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/prices">
          <icon name="document-list" class="mr-2 w-4 h-4" :class="isUrl('prices') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('prices') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Lista de precios</div>
        </Link>
      </div>
      <Link class="group flex items-center py-3" href="/discounts">
        <icon name="discount" class="mr-2 w-4 h-4" :class="isUrl('discounts') ? 'fill-white' :'fill-sky-400 group-hover:fill-white'" />
        <div :class="isUrl('discounts') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Descuentos</div>
      </Link>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/routes">
          <icon name="map-pin" class="mr-2 w-4 h-4" :class="isUrl('routes') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('routes') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Rutas</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/reports">
          <icon name="options" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('reports') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Reportes</div>
        </Link>
      </div>
      <div v-if="auth.user.role == 6" class="mb-4">
        <Link class="group flex items-center py-3" href="/liquidation">
          <icon name="discount" class="mr-2 w-4 h-4" :class="isUrl('liquidation') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('liquidation') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Liquidación</div>
        </Link>
      </div>
      <div class="mb-4">
        <MainMenuDropdownItem name="Ajustes" name_icon="settings" route="settings" class="group flex items-center py-3">
          <Link class="group flex items-center py-3" href="/settings/products/families">
            <icon name="rectangle-group" class="mr-2 w-4 h-4" :class="isUrl('settings/products/families') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/products/families') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Familias de productos</div>
          </Link>
          <Link class="group flex items-center py-3" href="/settings/products/categories">
            <icon name="clipboard-document" class="mr-2 w-4 h-4" :class="isUrl('settings/products/categories') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/products/categories') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Categorias de productos</div>
          </Link>
          <Link class="group flex items-center py-3" href="/settings/products/units">
            <icon name="cube" class="mr-2 w-4 h-4" :class="isUrl('settings/products/units') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/products/units') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Unidades de medida</div>
          </Link>
          <Link class="group flex items-center py-3" href="/settings/products/taxes">
            <icon name="discount" class="mr-2 w-4 h-4" :class="isUrl('settings/products/taxes') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/products/taxes') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Impuestos</div>
          </Link>
          <Link class="group flex items-center py-3" href="/settings/clients/categories">
            <icon name="category" class="mr-2 w-4 h-4" :class="isUrl('settings/clients/categories') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/clients/categories') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Categorias de clientes</div>
          </Link>
          <Link class="group flex items-center py-3" href="/settings/clients/types">
            <icon name="rectangle-group" class="mr-2 w-4 h-4" :class="isUrl('settings/clients/types') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('settings/clients/types') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Tipos de clientes</div>
          </Link>
          <Link class="group flex items-center py-3" href="/routes/sub-routes/list-day">
            <icon name="arrow-turn-up-right" class="mr-2 w-4 h-4" :class="isUrl('/routes/sub-routes/list-day') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
            <div :class="isUrl('/routes/sub-routes/list-day') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Días de ruta</div>
          </Link>
        </MainMenuDropdownItem>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/users">
          <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('users') ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
          <div :class="isUrl('users') ? 'text-white' : 'text-sky-300 group-hover:text-white'">Usuarios</div>
        </Link>
      </div>
    </div>        
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import MainMenuDropdownItem from '@/Shared/MainMenuDropdownItem'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
    MainMenuDropdownItem,
  },
  props: {
    auth: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    isUrl(...urls) {
      // console.log('current auth XD:', this.auth.user.role)
      // console.log('user XD:', this.auth.user.id)
      
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>